export default __webpack_public_path__ + "static/media/lobby-1920-2.0bb0d769.jpg";